/** Tutorial/FRE offen – zentral für UI-Sperre (Race mit async loadSignatures/refreshPlanBadge). */
export function isFreCarouselOpen(): boolean {
  const fre = document.getElementById("fre-carousel-section");
  if (!fre) return false;
  if (fre.getAttribute("aria-hidden") === "true") return false;
  const display = fre.style.display;
  return display !== "none" && display !== "";
}

export function setFreCarouselShellOpen(open: boolean): void {
  document.documentElement.classList.toggle("sunnysign-fre-open", open);
}
